/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */
import { getApiUrl } from "../api";
import { getStoredUser, isAuthenticated } from "../auth";
import { useEffect, useState } from "react";


const getStoredUserId = () => {
  const authenticatedUserId = getStoredUser()?.userId;
  if (authenticatedUserId && Number.isFinite(Number(authenticatedUserId))) return String(Number(authenticatedUserId));

  const keys = ["userId", "userid", "UserId", "boardid"];
  for (const key of keys) {
    const value = localStorage.getItem(key) || sessionStorage.getItem(key);
    if (value && Number.isFinite(Number(value))) return String(Number(value));
  }

  return "0";
};

const getAuthenticatedDonor = () => {
  if (!isAuthenticated()) return { name: "", email: "", phone: "", key: "guest" };

  const user = getStoredUser() || {};
  const profile = user.profile || {};
  const name = profile.fullname || user.userName || "";
  const email = profile.email || user.user || "";
  const phone = profile.phone || profile.mobileno || "";
  return { name, email, phone, key: `user-${user.userId || email || name}` };
};

const getNumericValue = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? String(number) : "0";
};

const generateTransactionId = () => {
  const now = new Date();
  const date = now.toISOString().slice(0, 10).replace(/-/g, "");
  const random = Math.random().toString(36).slice(2, 10).toUpperCase();
  return `TRH-${date}-${random}`;
};

export default function HomeModals(props) {
  const { selectedDonation = {} } = props || {};
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [donationError, setDonationError] = useState("");
  const [authenticatedDonor, setAuthenticatedDonor] = useState(getAuthenticatedDonor);
  const donationTitle = selectedDonation.title || "";
  const donationTypeLabel = selectedDonation.typeLabel || "Category";
  const donationCaseNo = selectedDonation.caseNo || "";
  const donationAmount = selectedDonation.amount || "";

  useEffect(() => {
    const refreshAuthenticatedDonor = () => setAuthenticatedDonor(getAuthenticatedDonor());
    window.addEventListener("auth:changed", refreshAuthenticatedDonor);
    window.addEventListener("storage", refreshAuthenticatedDonor);
    return () => {
      window.removeEventListener("auth:changed", refreshAuthenticatedDonor);
      window.removeEventListener("storage", refreshAuthenticatedDonor);
    };
  }, []);

  const handleDonateNow = async () => {
    const isArabicRoute = typeof window !== "undefined" && window.location.pathname.toLowerCase().startsWith("/ar");
    if (isSubmitting) return;

    const amountInput = document.getElementById("donationAmount");
    const donorNameInput = document.getElementById("donorName");
    const donorEmailInput = document.getElementById("donorEmail");
    const donorMobileInput = document.getElementById("donorMobile");
    const activeMethod = document.querySelector("#dntpopups .method-card.active");
    const amount = amountInput?.value?.trim() || "0";
    const name = donorNameInput?.value?.trim() || "";
    const email = donorEmailInput?.value?.trim() || "";
    const phone = donorMobileInput?.value?.trim() || "";
    const paymentmethod = activeMethod?.dataset.method || "Credit / Debit Card";

    setDonationError("");

    if (!amount || Number(amount) <= 0) {
      setDonationError(isArabicRoute ? "يرجى إدخال مبلغ تبرع صحيح." : "Please enter a valid donation amount.");
      amountInput?.focus();
      return;
    }

    if (!name) {
      setDonationError(isArabicRoute ? "يرجى إدخال الاسم." : "Please enter your name.");
      donorNameInput?.focus();
      return;
    }

    if (!email) {
      setDonationError(isArabicRoute ? "يرجى إدخال البريد الإلكتروني." : "Please enter your email.");
      donorEmailInput?.focus();
      return;
    }

    if (!phone) {
      setDonationError(isArabicRoute ? "يرجى إدخال رقم الهاتف." : "Please enter your mobile number.");
      donorMobileInput?.focus();
      return;
    }

    const transactionid = generateTransactionId();
    const receiptno = `RCT-${transactionid.replace(/^TRH-/, "")}`;
    const dt = new Date().toISOString();
    const formData = new FormData();
    formData.append("userid", getStoredUserId());
    formData.append("catid", getNumericValue(selectedDonation.catid));
    formData.append("subcatid", getNumericValue(selectedDonation.subcatid));
    formData.append("projectid", getNumericValue(selectedDonation.projectid));
    formData.append("amount", amount);
    formData.append("dt", dt);
    formData.append("transactionid", transactionid);
    formData.append("receiptno", receiptno);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("paymentmethod", paymentmethod);
    const normalizedPaymentMethod = paymentmethod.toLowerCase().replace(/[\s/]+/g, "");
    const isDubaiPay = normalizedPaymentMethod === "dubaipay";
    const isCCAvenue = normalizedPaymentMethod === "creditdebitcard" || normalizedPaymentMethod === "ccavenue";
    const isGatewayPayment = isDubaiPay || isCCAvenue;
    formData.append("status", isGatewayPayment ? "pending" : "success");
    formData.append("response_message", isDubaiPay
      ? "Dubai Pay payment initiated."
      : (isCCAvenue ? "CCAvenue payment initiated." : "Saved directly without payment gateway integration"));

    try {
      setIsSubmitting(true);
      const headers = { Accept: "application/json" };
      const response = await fetch(getApiUrl("/api/DonationAdd.ashx"), {
        method: "POST",
        headers,
        body: formData,
      });

      const result = await response.json().catch(() => null);
      if (!response.ok || !result?.success) {
        throw new Error(isArabicRoute ? "تعذر حفظ التبرع. يرجى المحاولة مرة أخرى." : (result?.message || "Unable to save donation."));
      }

      const summary = {
        amount,
        donationTitle,
        donationTypeLabel,
        transactionid: result.transactionid || transactionid,
        receiptno: result.receiptno || receiptno,
        dt,
        paymentmethod,
        name,
        email,
        phone,
        status: result.status || (isGatewayPayment ? "pending" : "success"),
      };
      sessionStorage.setItem("lastDonation", JSON.stringify(summary));

      if (result.paymentRequired && result.paymentUrl) {
        if (String(result.paymentMethod || "").toUpperCase() === "POST" && result.paymentFields) {
          const paymentForm = document.createElement("form");
          paymentForm.method = "POST";
          paymentForm.action = result.paymentUrl;
          paymentForm.style.display = "none";
          Object.entries(result.paymentFields).forEach(([fieldName, fieldValue]) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = fieldName;
            input.value = String(fieldValue ?? "");
            paymentForm.appendChild(input);
          });
          document.body.appendChild(paymentForm);
          paymentForm.submit();
          return;
        }
        window.location.href = result.paymentUrl;
        return;
      }

      window.location.href = "/after-payment";
    } catch (error) {
      setDonationError(isArabicRoute ? "تعذر حفظ التبرع. يرجى المحاولة مرة أخرى." : (error.message || "Unable to save donation."));
    } finally {
      setIsSubmitting(false);
    }
  };

  const isArabic = typeof window !== "undefined" && window.location.pathname.toLowerCase().startsWith("/ar");
  const text = isArabic ? {
    amount: "مبلغ التبرع", currency: "درهم", amountHelp: "أدخل مبلغ التبرع", secure: "جميع المعاملات آمنة ومشفرة وتلتزم بأعلى معايير الأمان.", userInfo: "معلومات المستخدم", name: "الاسم", enterName: "أدخل الاسم", email: "البريد الإلكتروني", enterEmail: "أدخل البريد الإلكتروني", mobile: "رقم الهاتف", enterMobile: "أدخل رقم الهاتف", payment: "وسيلة الدفع", card: "بطاقة ائتمان / خصم", donate: "تبرع الآن", saving: "جارٍ الحفظ...", trusted: "تبرع آمن وموثوق"
  } : {
    amount: "Donation Amount", currency: "AED", amountHelp: "Enter the amount you wish to donate", secure: "All transactions are secure, encrypted, and comply with the highest security standards.", userInfo: "User Information", name: "Name", enterName: "Enter your name", email: "Email", enterEmail: "Enter your email", mobile: "Mobile Number", enterMobile: "Enter mobile number", payment: "Payment Method", card: "Credit / Debit Card", donate: "Donate Now", saving: "Saving...", trusted: "Secure and trusted donation"
  };

  return (
    <>
    <div className="dntpopups" id="dntpopups">
      <div className="donation-overlay">
        <div className="donation-modal">
          <button className="close-popup" id="closeDonation">
            {"×"}
          </button>
          <div className="main-form">
            <div className="modal-body">
              <div className="left-col">
                <div className="header-title">
                  <h2 className="field-title">
                    {donationTitle}
                  </h2>
                  <div className="cse-nom">
                    {donationTypeLabel}
                    {donationCaseNo ? (
                      <>
                        {" | Case No. "}
                        <span>{donationCaseNo}</span>
                      </>
                    ) : null}
                  </div>
                </div>
                <h3 className="field-title">
                  {text.amount}
                </h3>
                <div className="amount-box">
                  <div className="currency">
                    {text.currency}
                  </div>
                  <input type="number" id="donationAmount" key={selectedDonation.id + "-" + donationAmount} defaultValue={donationAmount} min="1" />
                </div>
                <p className="help-text">
                  {text.amountHelp}
                </p>
                <div className="secure-box">
                  <div className="secure-icon">
                    <img src="/images/img/secure.svg" width="45px" alt="" />
                  </div>
                  <p>
                    {text.secure}
                  </p>
                </div>
              </div>
              <div className="right-col">
                <div className="user-info-section">
                  <h3 className="field-title">
                    {text.userInfo}
                  </h3>
                  <div className="user-info-grid">
                    <div className="user-info-field">
                      <label htmlFor="donorName">
                        {text.name}
                      </label>
                      <input key={`name-${authenticatedDonor.key}-${selectedDonation.id || "default"}`} type="text" id="donorName" name="donorName" defaultValue={selectedDonation.donorName || authenticatedDonor.name} placeholder={text.enterName} autoComplete="name" />
                    </div>
                    <div className="user-info-field">
                      <label htmlFor="donorEmail">
                        {text.email}
                      </label>
                      <input key={`email-${authenticatedDonor.key}-${selectedDonation.id || "default"}`} type="email" id="donorEmail" name="donorEmail" defaultValue={selectedDonation.donorEmail || authenticatedDonor.email} placeholder={text.enterEmail} autoComplete="email" />
                    </div>
                    <div className="user-info-field">
                      <label htmlFor="donorMobile">
                        {text.mobile}
                      </label>
                      <input key={`phone-${authenticatedDonor.key}-${selectedDonation.id || "default"}`} type="tel" id="donorMobile" name="donorMobile" defaultValue={selectedDonation.donorPhone || authenticatedDonor.phone} placeholder={text.enterMobile} autoComplete="tel" />
                    </div>
                  </div>
                </div>
                <h3 className="field-title">
                  {text.payment}
                </h3>
                <div className="method-list">
                  <div className="method-card active" data-method="Credit / Debit Card">
                    <span className="radio"></span>
                    <span className="method-name">
                      {text.card}
                    </span>
                    <span className="method-icon">
                      <img src="/images/img/credit-card.png" alt="" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {donationError ? (
              <div className="donation-error">
                {donationError}
              </div>
            ) : null}
            <button className="donate-now" type="button" disabled={isSubmitting} onClick={handleDonateNow}>
              {isSubmitting ? text.saving : text.donate}
            </button>
            <div className="bottom-secure">
              <img src="/images/img/lock.svg" width="25px" alt="" />
              {`  ${text.trusted}`}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="zakat-popup-overlay" id="zakatPopup">
      <div className="zakat-popup-card">
        <div className="zakat-popup-head">
          <button className="zakat-close-btn" id="closeZakatPopup">
            {"×"}
          </button>
          <div className="zakat-icon-box">
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
              <rect x="3" y="7" width="18" height="13" rx="2"></rect>
              <path d="M7 7V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"></path>
              <path d="M3 11h18"></path>
              <path d="M16 15h2"></path>
            </svg>
          </div>
          <h2>
            {"Zakat Calculation"}
          </h2>
          <p>
            {"\n          Use this calculator to quickly estimate the amount of zakat you need to pay.\n        "}
          </p>
        </div>
        <div className="zakat-popup-body">
          <div className="zakat-field">
            <label htmlFor="zakatAmount">
              {"Enter Amount"}
            </label>
            <div className="zakat-input-wrap">
              <span className="zakat-currency">
                {"AED"}
              </span>
              <input type="number" id="zakatAmount" className="zakat-input" placeholder="Enter your amount" />
            </div>
          </div>
          <div className="zakat-field">
            <label>
              {"Calculated Zakat (2.5%)"}
            </label>
            <div className="zakat-result-box" id="zakatResult">
              {"AED 0.00"}
            </div>
          </div>
          <div className="zakat-actions">
            <button className="zakat-calc-btn" id="calculateZakatBtn">
              {"Calculate"}
            </button>
            <button className="zakat-reset-btn" id="resetZakatBtn" type="button">
              {"Reset"}
            </button>
          </div>
          <div className="zakat-note">
            {"\n          Standard zakat is generally calculated as "}
            <strong>
              {"2.5%"}
            </strong>
            {" of the eligible amount.\n        "}
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
